import { StyledMain } from "./styles";
import { Techs } from "../Techs";
import React from "react";

function Dashboard() {
  return (
    <StyledMain>
      <Techs />
    </StyledMain>
  );
}

export { Dashboard };
